import React, { useEffect } from "react";
import ReactHtmlParser from "react-html-parser";
import "./style.css";

function Compnay(props) {
  const { content } = props.data;
  console.log(content);

  return (
    <div className="row company_container">
      <div className="col m10 offset-m1">
        <div className="card card-content z-depth-2">
          <p className="main-paragraph">
            {ReactHtmlParser(content.company.description)}
          </p>
          <div className="row ">
           
              <ul className="collection wit_label_collection">
                {content.detail.map((val) => {
                  return (
                    <li className="collection-item">
                      <div className="company_label">
                        <p>{ReactHtmlParser(val.label)}</p>
                      </div>
                      <div className="company_value">
                        <p>{ReactHtmlParser(val.value)}</p>
                      </div>
                    </li>
                  );
                })}
              </ul>
            
          </div>
          <div className="row center">
            <iframe
              className="map"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d708.0633174650935!2d96.0727503893983!3d21.98855336997667!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x65f002a40027bc49!2sClover+Mandalay+Co.%2CLtd!5e0!3m2!1sen!2sus!4v1566295786151!5m2!1sen!2sus"
              width="600"
              height="450"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Compnay;
